"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMAIL_TEMPLATES = exports.LINKEDIN_TEMPLATES = exports.WA_TEMPLATES = void 0;
exports.buildWAMessage = buildWAMessage;
exports.buildLinkedInMessage = buildLinkedInMessage;
exports.buildEmailMessage = buildEmailMessage;
exports.buildWALink = buildWALink;
// NOTE: WhatsApp templates intentionally OMIT the "Thank you for connecting" line.
// That line only makes sense on LinkedIn (after a connection request is accepted),
// so it lives exclusively in the LINKEDIN_TEMPLATES below.
exports.WA_TEMPLATES = {
    id: {
        label: 'Bahasa Indonesia',
        template: `Halo {candidateName},

Perkenalkan, saya {consultantName}, {consultantPosition} dari Canis Major. Kami adalah executive search firm dengan jangkauan regional di Indonesia, Singapura, dan Hong Kong. Kami berfokus menempatkan pemimpin berdampak tinggi di perusahaan-perusahaan terkemuka di kawasan ini.

Saat ini saya sedang membantu klien kami untuk merekrut posisi {roleName}. Klien kami, {clientDescription}, sedang mencari individu berdampak tinggi untuk {rolePurpose}.

Mengingat latar belakang Anda yang kuat di bidang {candidateExpertise} di berbagai organisasi, saya ingin sekali mendiskusikan bagaimana kesempatan baru ini dapat selaras dengan pengalaman Anda. Apakah Anda bersedia untuk berdiskusi singkat dan konfidensial {proposedDate}? Silakan usulkan waktu lain yang sesuai juga, terima kasih dan saya menantikan kesempatan untuk terhubung dengan Anda.

Saya menantikan kabar dari Anda.

Salam,
{consultantName}`
    },
    en: {
        label: 'English',
        template: `Hi {candidateName},

I'm {consultantName}, a {consultantPosition} from Canis Major. We are an executive search firm with a regional footprint across Indonesia, Singapore, and Hong Kong. We specialise in placing high-impact leadership within top-tier companies in the region.

I'm currently helping a client to recruit for a {roleName} position. Our client, {clientDescription} is seeking a high-impact individual to {rolePurpose}.

Given your strong background in {candidateExpertise} at various organisations I'd love to discuss how this new opportunity might align well with your experience. Would you be open to a brief, confidential sync {proposedDate}? Feel free to suggest other timings too, thank you and looking forward to connecting with you.

I look forward to hearing from you.

Cheers,
{consultantName}`
    }
};
exports.LINKEDIN_TEMPLATES = {
    id: {
        label: 'Bahasa Indonesia',
        template: `Halo {candidateName},

Terima kasih telah terhubung.

Perkenalkan, saya {consultantName}, {consultantPosition} dari Canis Major. Kami adalah executive search firm dengan jangkauan regional di Indonesia, Singapura, dan Hong Kong. Kami berfokus menempatkan pemimpin berdampak tinggi di perusahaan-perusahaan terkemuka di kawasan ini.

Saat ini saya sedang membantu klien kami untuk merekrut posisi {roleName}. Klien kami, {clientDescription}, sedang mencari individu berdampak tinggi untuk {rolePurpose}.

Mengingat latar belakang Anda yang kuat di bidang {candidateExpertise} di berbagai organisasi, saya ingin sekali mendiskusikan bagaimana kesempatan baru ini dapat selaras dengan pengalaman Anda. Apakah Anda bersedia untuk berdiskusi singkat dan konfidensial {proposedDate}? Silakan usulkan waktu lain yang sesuai juga, terima kasih dan saya menantikan kesempatan untuk terhubung dengan Anda.

Saya menantikan kabar dari Anda.

Salam,
{consultantName}`
    },
    en: {
        label: 'English',
        template: `Hi {candidateName},

Thank you for connecting.

I'm {consultantName}, a {consultantPosition} from Canis Major. We are an executive search firm with a regional footprint across Indonesia, Singapore, and Hong Kong. We specialise in placing high-impact leadership within top-tier companies in the region.

I'm currently helping a client to recruit for a {roleName} position. Our client, {clientDescription} is seeking a high-impact individual to {rolePurpose}.

Given your strong background in {candidateExpertise} at various organisations I'd love to discuss how this new opportunity might align well with your experience. Would you be open to a brief, confidential sync {proposedDate}? Feel free to suggest other timings too, thank you and looking forward to connecting with you.

I look forward to hearing from you.

Cheers,
{consultantName}`
    }
};
// Email outreach: a more formal variant of the message, with a subject line.
exports.EMAIL_TEMPLATES = {
    id: {
        label: 'Bahasa Indonesia',
        subject: `Kesempatan Karier {roleName} — Canis Major`,
        template: `Yth. {candidateName},

Perkenalkan, saya {consultantName}, {consultantPosition} dari Canis Major. Kami adalah executive search firm dengan jangkauan regional di Indonesia, Singapura, dan Hong Kong. Kami berfokus menempatkan pemimpin berdampak tinggi di perusahaan-perusahaan terkemuka di kawasan ini.

Saat ini saya sedang membantu klien kami untuk merekrut posisi {roleName}. Klien kami, {clientDescription}, sedang mencari individu berdampak tinggi untuk {rolePurpose}.

Mengingat latar belakang Anda yang kuat di bidang {candidateExpertise} di berbagai organisasi, saya ingin sekali mendiskusikan bagaimana kesempatan baru ini dapat selaras dengan pengalaman Anda. Apakah Anda bersedia untuk berdiskusi singkat dan konfidensial {proposedDate}? Silakan usulkan waktu lain yang sesuai juga.

Saya menantikan kabar dari Anda.

Hormat saya,
{consultantName}
Canis Major`
    },
    en: {
        label: 'English',
        subject: `{roleName} Opportunity — Canis Major`,
        template: `Dear {candidateName},

I'm {consultantName}, a {consultantPosition} from Canis Major. We are an executive search firm with a regional footprint across Indonesia, Singapore, and Hong Kong. We specialise in placing high-impact leadership within top-tier companies in the region.

I'm currently helping a client to recruit for a {roleName} position. Our client, {clientDescription} is seeking a high-impact individual to {rolePurpose}.

Given your strong background in {candidateExpertise} at various organisations, I'd love to discuss how this new opportunity might align well with your experience. Would you be open to a brief, confidential sync {proposedDate}? Feel free to suggest other timings too.

I look forward to hearing from you.

Best regards,
{consultantName}
Canis Major`
    }
};
function applyReplacements(template, params) {
    return template
        .replace(/{candidateName}/g, params.candidateName)
        .replace(/{consultantName}/g, params.consultantName)
        .replace(/{consultantPosition}/g, params.consultantPosition)
        .replace(/{roleName}/g, params.roleName)
        .replace(/{clientDescription}/g, params.clientDescription)
        .replace(/{rolePurpose}/g, params.rolePurpose)
        .replace(/{candidateExpertise}/g, params.candidateExpertise)
        .replace(/{proposedDate}/g, params.proposedDate);
}
function buildWAMessage(language, params) {
    return applyReplacements(exports.WA_TEMPLATES[language].template, params);
}
function buildLinkedInMessage(language, params) {
    return applyReplacements(exports.LINKEDIN_TEMPLATES[language].template, params);
}
function buildEmailMessage(language, params) {
    return {
        subject: applyReplacements(exports.EMAIL_TEMPLATES[language].subject, params),
        body: applyReplacements(exports.EMAIL_TEMPLATES[language].template, params)
    };
}
function buildWALink(phone, message) {
    const cleanPhone = phone.replace(/[\s\-()]/g, '').replace(/^\+/, '');
    return `https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`;
}
//# sourceMappingURL=wa-templates.js.map